import { render, staticRenderFns } from "./NewClinicSection.vue?vue&type=template&id=2104a104&scoped=true&"
import script from "./NewClinicSection.vue?vue&type=script&lang=js&"
export * from "./NewClinicSection.vue?vue&type=script&lang=js&"
import style0 from "./NewClinicSection.vue?vue&type=style&index=0&id=2104a104&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2104a104",
  null
  
)

export default component.exports